var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"search-trigger",on:{"click":function($event){$event.preventDefault();return _vm.toggle()}}},[_c('i',{staticClass:"fa fa-search fa-fw"})])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-212afc19","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/src/components/Search/SearchTrigger.vue
// module id = kaqD
// module chunks = 1